<template>
 <router-view></router-view>
</template>

<script>
export default {
  name: "H2p",
};
</script>
<style lang="scss">
</style>